export default __webpack_public_path__ + "static/media/ebloc2.2f31c0d4.png";